import * as Yup from 'yup';

export default Yup
  .string()
  .trim()
  .matches(/^\(\d{2}\) \d{4,5}-\d{4}$/, 'Telefone para contato inválido')
  .nullable();
